import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getAllLore, getLoreById } from 'utils/LoreAPI';
import { Lore } from 'types/Lore';
import { routes } from '../routing/routes';

export default function useLore(id?: string) {
  const [allLore, setAllLore] = useState<Lore[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const getById = (id: string) => {
    return allLore.find((lore) => lore.id === id);
  };

  useEffect(() => {
    const handleError = (error: unknown) => {
      if (error instanceof Error) {
        if (error.message === 'The resource could not be found.') {
          navigate(routes['404']());
          return;
        }
      }

      throw error;
    };

    const fetchAllLore = async () => {
      const allLore = await getAllLore();
      setAllLore(allLore);
      setIsLoading(false);
    };

    const fetchLoreById = async (id: string) => {
      const lore = await getLoreById(id);

      if (lore) {
        setAllLore([lore]);
      }

      setIsLoading(false);
    };

    const fetchData = async () => {
      try {
        if (id) {
          await fetchLoreById(id);
        } else {
          await fetchAllLore();
        }
      } catch (error) {
        handleError(error);
      }
    };

    fetchData();
  }, [id, navigate]);

  return {
    allLore,
    isLoading,
    getById,
  };
}
